import React from 'react';
import * as R from 'ramda';
import { useSelector } from 'react-redux';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';
import { FormattedMessage } from '../i18n';
import { getIsMicrodata } from '../selectors/microdata';
import { countNumberOf } from '../utils';
import { getRefinedDataRange } from '../selectors/sdmx';
import useFilterFrequency from '../hooks/useFilterFrequency';
import useGetUsedFilters from '../hooks/useGetUsedFilters';

const VisDataPoints = () => {
  const theme = useTheme();
  const isMicrodata = useSelector(getIsMicrodata);
  const range = useSelector(getRefinedDataRange);
  const { frequencyFilter = [], periodFilter = [] } = useFilterFrequency();
  const selection = useGetUsedFilters();
  const isNarrow = useMediaQuery(theme.breakpoints.down('sm'));
  const style = { marginTop: isNarrow ? 0 : theme.spacing(-2.5) };
  const counter = countNumberOf(
    R.concat(selection, R.concat(frequencyFilter, periodFilter)),
  );
  const obsCount = R.propOr(0, 'total', range);

  if (isMicrodata || counter !== 0 || obsCount === 0) return null;

  return (
    <div style={style}>
      <Typography variant="body2" color="textSecondary" tabIndex={0}>
        <FormattedMessage id="de.vis.data.points" values={{ obsCount }} />
      </Typography>
    </div>
  );
};

export default VisDataPoints;
